
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solutions/property-and-casualty-insurance",
      function () {
        return require("private-next-pages/solutions/property-and-casualty-insurance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solutions/property-and-casualty-insurance"])
      });
    }
  